import { defineComponent, computed, watch, ref } from "vue";
import { definePropType } from "@types-vue/props";
import MessageContent from "@pt/views/layout/components/warrant-message/content.vue";
export default defineComponent({
    components: {
        MessageContent: MessageContent
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        content: {
            type: definePropType(Array),
            default: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var activeName = ref("");
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                activeName.value = props.content[0].lang;
            }
        }, {
            immediate: true
        });
        return {
            dialogVisible: dialogVisible,
            activeName: activeName
        };
    }
});
